import { PropsWithChildren } from "react"
import { useHasRole } from "../../api"
import { Role } from "raml-lib"

export function EditorOnly(props: PropsWithChildren<{}>) {
  const authorised = useHasRole(Role.EDITOR)

  if (authorised) {
    return <>{props.children}</>
  } else {
    return null
  }
}
